module.exports = __webpack_public_path__ + "static/media/preview.d02a16e0.webp";